import script from "./Doughnut.vue?vue&type=script&setup=true&lang=js"
export * from "./Doughnut.vue?vue&type=script&setup=true&lang=js"

import "./Doughnut.vue?vue&type=style&index=0&id=1b01ea32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b01ea32"]])

export default __exports__